import { Link } from 'react-router-dom'

export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-surface-dark p-4 sm:p-6 pb-20">
      <div className="max-w-2xl mx-auto">
        <Link to="/" className="text-accent hover:text-accent-hover mb-8 block">
          ← Back
        </Link>

        <h1 className="text-headline-lg mb-8">Privacy Policy</h1>

        <div className="prose prose-invert max-w-none space-y-6">
          <section>
            <h2 className="text-headline-md mb-3">1. Information We Collect</h2>
            <p className="text-body-md text-text-secondary">
              When you submit a report, we collect:
              Your photograph, location (address or GPS), issue category, and optional description.
              If you create an account, we also collect your email and name.
            </p>
          </section>

          <section>
            <h2 className="text-headline-md mb-3">2. How We Use Your Information</h2>
            <p className="text-body-md text-text-secondary">
              We use your report data to:
              Route it to the responsible organization for action.
              Track the status of infrastructure issues.
              Improve our service with your feedback (anonymized).
            </p>
          </section>

          <section>
            <h2 className="text-headline-md mb-3">3. Data Sharing</h2>
            <p className="text-body-md text-text-secondary">
              Your report is shared with the responsible organization only.
              We never share your personal email or contact information with organizations unless you explicitly request follow-up.
              Your data is never sold to third parties.
            </p>
          </section>

          <section>
            <h2 className="text-headline-md mb-3">4. Data Security</h2>
            <p className="text-body-md text-text-secondary">
              All data is transmitted over HTTPS and stored securely.
              We comply with data protection regulations.
            </p>
          </section>

          <section>
            <h2 className="text-headline-md mb-3">5. Contact</h2>
            <p className="text-body-md text-text-secondary">
              Questions? Email us at privacy@snagmatic.com
            </p>
          </section>
        </div>
      </div>
    </div>
  )
}
